"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _utils = require("./utils");

var batteryId = _utils.screeners.ROI_HPQ_3;
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: ""
};
var daysPerWeek = ["0", "1", "2", "3", "4", "5", "6", "7"];
var hoursPerWeek = ["0", "1", "2", "3", "4", "5", "6", "7 or more"];
var roiQuestions = [// ROI measures (based on HPQ) - 3 questions
{
  prompt: "On how many days in the last week did your stress levels cause you" + " to miss work or leave you unable to carry out your normal daily duties?",
  options: daysPerWeek
}, {
  prompt: "On how many days in the last week did you feel so impaired by stress," + " that even though you went to work, your productivity was reduced?",
  options: daysPerWeek
}, {
  prompt: "How many hours per day do you feel your work is unproductive?",
  options: hoursPerWeek
}];
var questions = (0, _utils.wrapBattery)(roiQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var humanReadable = {};
  questions.forEach(function (q, i) {
    humanReadable[q.prompt] = answers[i];
  });
  return {
    roiAbsenteeismDays: answers[0],
    roiPresenteeismDays: answers[1],
    roiUnproductiveHours: answers[2],
    humanReadable: humanReadable
  };
}